import React from 'react';
import { Box, Typography, Chip, useTheme } from '@mui/material';
import { useOffline } from '../contexts/OfflineContext';

const OfflineIndicator = () => {
  const { isOnline } = useOffline();
  const theme = useTheme();

  if (isOnline) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 80,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#ef4444',
        color: 'white',
        padding: '8px 16px',
        borderRadius: '20px',
        fontSize: '0.9rem',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)'
      }}
    >
      <Typography variant="body2">
        🔴 Sin conexión - Modo offline activado
      </Typography>
    </Box>
  );
};

export default OfflineIndicator;
